export class HookOutOfContextError extends Error {
  constructor(hookName: string, contextName: string) {
    super(`${hookName} has to be rendered within ${contextName} scope`);
  }
}
